import rootReducer from "redux/root-reducer";
import {
  FLUSH,
  REGISTER,
  REHYDRATE,
  PAUSE,
  PURGE,
} from "redux-persist";
import { configureStore } from "@reduxjs/toolkit";

const configureStores = () => {
  const store = configureStore({
    reducer: rootReducer,
    devTools: process.env.NODE_ENV !== "production",
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REGISTER, REHYDRATE, PAUSE, PURGE],
        },
      }),
  });
  return { store };
};

export default configureStores;
